<app-dialog-wrapper [isClosing]="isClosing" (animationend)="onAnimationEnd()">

    <div class="w-full p-2 flex-1">
      <!-- Bouton Retour -->
      <div class="flex justify-end gap-2 mt-4">
        <button (click)="onCancel()" class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">
          Retour
        </button>
      </div>

      <div class="m-4">
        <h2 class="text-lg font-bold text-center mb-4">Récapitulatif de paiement</h2>
      </div>

      <!-- LISTE DES ARTICLES (scrollable uniquement ici) -->
      <div class="overflow-y-auto max-h-[13vh] pr-2">
        <div *ngFor="let item of data.items" class="flex justify-between text-gray-700">
          <span>{{ item.name }}</span>
          <span>
            {{ item.total_ttc | number:data.currencyFormat.decimalsString }}
            {{ data.currencyFormat.currencySymbol }}
          </span>
        </div>
      </div>

      <!-- TOTAUX -->
      <div class="border-t border-gray-300 p-4 text-gray-700">
        <div class="flex justify-between mb-1">
          <span>Total :</span>
          <span>{{ data.totalAmount | number:data.currencyFormat.decimalsString }} {{ data.currencyFormat.currencySymbol
            }}</span>
        </div>
        <div class="flex justify-between mb-1">
          <span>Déjà payé :</span>
          <span>{{ data.alreadyPaidAmount | number:data.currencyFormat.decimalsString }} {{
            data.currencyFormat.currencySymbol }}</span>
        </div>
        <div class="flex justify-between mb-1">
          <span>Montant maximum :</span>
          <span>{{ data.totalAmount - data.alreadyPaidAmount | number:data.currencyFormat.decimalsString }} {{
            data.currencyFormat.currencySymbol }}</span>
        </div>
      </div>

      <!-- AUTRES INFOS -->
      <div class="border-t border-gray-300 p-4 text-gray-700">
        <div *ngIf="data.returnAmount !== data.totalAmount" class="flex justify-between mb-1">
          <span>Montant choisi :</span>
          <span>{{ data.returnAmount | number:data.currencyFormat.decimalsString }} {{
            data.currencyFormat.currencySymbol }}</span>
        </div>
        <div class="flex justify-between mb-1" *ngIf="data.tipAmount > 0">
          <span>Pourboire :</span>
          <span>{{ data.tipAmount | number:data.currencyFormat.decimalsString }} {{ data.currencyFormat.currencySymbol
            }}</span>
        </div>
        <div
          *ngIf="data.returnAmount !== data.totalAmount && data.returnAmount > (data.totalAmount - data.alreadyPaidAmount)"
          class="flex justify-between mb-1">
          <span>Montant choisi rectifié :</span>
          <span>{{ data.totalAmount - data.alreadyPaidAmount | number:data.currencyFormat.decimalsString }} {{
            data.currencyFormat.currencySymbol }}</span>
        </div>
        <div class="flex justify-between font-semibold">
          <span>Montant final :</span>
          <span *ngIf="data.returnAmount <= (data.totalAmount - data.alreadyPaidAmount)">
            {{ (data.returnAmount + data.tipAmount) | number:data.currencyFormat.decimalsString }} {{
            data.currencyFormat.currencySymbol }}
          </span>
          <span *ngIf="data.returnAmount > (data.totalAmount - data.alreadyPaidAmount)">
            {{ ((data.totalAmount - data.alreadyPaidAmount) + data.tipAmount) |
            number:data.currencyFormat.decimalsString }} {{ data.currencyFormat.currencySymbol }}
          </span>
        </div>
      </div>

      <!-- BOUTON PAYER -->
      <div class="flex justify-end gap-2 mt-4">
        <button (click)="onConfirm()"
          [disabled]="data.returnAmount + data.tipAmount < 1 || (data.totalAmount - data.alreadyPaidAmount) < 1"
          class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full">
          Payer
        </button>
      </div>
    </div>
  </app-dialog-wrapper>
